var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.givenName || !!_vm.familyName)?_c('div',{staticClass:"avatar",style:({ backgroundColor: _vm.backgroundColor })},[_c('span',{staticClass:"is-uppercase has-text-weight-bold"},[_c('SensitiveField',[_vm._v(_vm._s(_vm.initials))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }